/* eslint-disable import/no-duplicates */
import { format as fnsFormat } from 'date-fns';
import { ru } from 'date-fns/locale';

export type DateInput = string | number | Date;

/**
 * Приводит различные представления даты к объекту Date.
 * Числовой вход трактуется как Unix-timestamp в секундах (умножается на 1000).
 * Возвращает `null`, если результат — невалидная дата.
 */
export function toDate (input: DateInput): Date | null {
  let date: Date;

  if (input instanceof Date) {
    date = input;
  } else if (typeof input === 'number') {
    date = new Date(input * 1000);
  } else {
    date = new Date(input);
  }

  return isNaN(date.getTime()) ? null : date;
}

interface FormatDateOptions {
  capitalize?: boolean;
}

/**
 * Парсит вход через `toDate` и форматирует по шаблону date-fns.
 * Возвращает `null`, если вход невалиден.
 */
export function formatDate (
  input: DateInput | null | undefined,
  fmt: string = 'dd.MM.yyyy',
  options?: FormatDateOptions,
): string | null {
  if (input == null) {
    return null;
  }

  const d = toDate(input);
  if (!d) {
    return null;
  }

  const result = fnsFormat(d, fmt, { locale: ru });
  if (options?.capitalize && result) {
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
  return result;
}
